import {
    Box,
    Text,
    HStack,
    Button,
} from "@chakra-ui/react";
import { Mail, Mails } from "lucide-react";

const FAQSupportCard = ({
    onOpen,
}) => {
    return (
        <Box
            mt={10}
            p={8}
            bg="#F5F8FF"
            borderRadius="20px"
            textAlign="center"
        >
            <Text
                fontSize="2xl"
                fontWeight="700"
                mb={3}
                color={"#071D54"}
            >
                Still need help?
            </Text>

            <Text
                color="gray.500"
                mb={6}
            >
                Our support team is available 24/7.
            </Text>

            <HStack
                justify="center"
                gap={4}
            >
                <Button
                bg="#2453FF"
                color="white"
                onClick={
                    onOpen
                }
            >
                <Mails
                    size={18}
                />

                Create Support Ticket
            </Button>

               
            </HStack>
        </Box>
    );
};

export default FAQSupportCard;